var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplaint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5798 8.26157H15.5873M15.5875 6.42492V4.12911M20.1667 6.22598C20.1667 8.65178 18.1128 10.6186 15.5798 10.6186C15.2819 10.619 14.985 10.5914 14.6924 10.5364C14.4818 10.4968 14.3766 10.4771 14.3031 10.4883C14.2295 10.4995 14.1254 10.5549 13.9171 10.6659C13.3278 10.9796 12.6405 11.0905 11.9796 10.9674C12.2308 10.6581 12.4024 10.287 12.478 9.88916C12.5239 9.64588 12.4103 9.40947 12.24 9.2365C11.4669 8.45053 10.9929 7.39149 10.9929 6.22598C10.9929 3.80016 13.0468 1.83331 15.5798 1.83331C18.1128 1.83331 20.1667 3.80016 20.1667 6.22598Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87665 20.1666H4.32491C4.02856 20.1666 3.73094 20.1249 3.45875 20.008C2.57269 19.6273 2.12314 19.1247 1.91363 18.8102C1.79442 18.6312 1.81141 18.4033 1.94074 18.2316C2.96732 16.868 5.34748 16.0444 6.87665 16.0443M6.88101 20.1666H9.43278C9.72914 20.1666 10.0267 20.1249 10.2989 20.008C11.185 19.6273 11.6345 19.1247 11.8441 18.8102C11.9632 18.6312 11.9463 18.4033 11.8169 18.2316C10.7904 16.868 8.41019 16.0444 6.88101 16.0443M9.4282 11.2647C9.4282 12.6684 8.28778 13.8063 6.88101 13.8063C5.47424 13.8063 4.33384 12.6684 4.33384 11.2647C4.33384 9.86102 5.47424 8.72308 6.88101 8.72308C8.28778 8.72308 9.4282 9.86102 9.4282 11.2647Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaint);
export default __webpack_public_path__ + "static/media/complaint.45b8d817b800cc07022b832101d8b3ed.svg";
export { ForwardRef as ReactComponent };